import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
// 获取基础的筛选项
import { OK } from '@/common';
import { getPlatformsList } from '@/api/payManage/appManage';
export var MarketTypeEnum;
(function (MarketTypeEnum) {
  MarketTypeEnum[MarketTypeEnum["ALL"] = -1] = "ALL";
  MarketTypeEnum[MarketTypeEnum["ANDROID"] = 1] = "ANDROID";
  MarketTypeEnum[MarketTypeEnum["IOS"] = 2] = "IOS";
  MarketTypeEnum[MarketTypeEnum["GOOGLE"] = 3] = "GOOGLE";
  MarketTypeEnum[MarketTypeEnum["MINIGAME"] = 4] = "MINIGAME";
})(MarketTypeEnum || (MarketTypeEnum = {}));
const allMarketList = [{
  label: '全部',
  value: MarketTypeEnum.ALL
}];
export const useMarketList = () => {
  const marketList = ref([]); // 市场列表
  // 获取工作室列表的函数
  const getMarketList = async () => {
    try {
      const {
        code,
        data: {
          markets
        }
      } = await getPlatformsList();
      if (code === OK) {
        var _markets$map;
        marketList.value = [...allMarketList, ...((_markets$map = markets === null || markets === void 0 ? void 0 : markets.map(item => ({
          ...item,
          publishPlatforms: item.publishPlatformInfos.map(temp => temp.publishPlatform),
          label: item.marketName,
          value: item.marketType
        }))) !== null && _markets$map !== void 0 ? _markets$map : [])];
        const order = [MarketTypeEnum.ALL, MarketTypeEnum.IOS, MarketTypeEnum.GOOGLE, MarketTypeEnum.ANDROID, MarketTypeEnum.MINIGAME];
        const indexMap = new Map(order.map((v, i) => [v, i]));
        marketList.value = marketList.value.sort((a, b) => {
          var _indexMap$get, _indexMap$get2;
          return ((_indexMap$get = indexMap.get(a.value)) !== null && _indexMap$get !== void 0 ? _indexMap$get : 999) - ((_indexMap$get2 = indexMap.get(b.value)) !== null && _indexMap$get2 !== void 0 ? _indexMap$get2 : 999);
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  onBeforeMount(() => {
    getMarketList();
  });
  return {
    MarketTypeEnum,
    marketList
  };
};